const createActionName = require('../util').createActionName('fimlab');

export const GET_FIMLAB_LABORATORIES = createActionName(
  'GET_FIMLAB_LABORATORIES'
);
export const RECEIVE_FIMLAB_LABORATORIES = createActionName(
  'RECEIVE_FIMLAB_LABORATORIES'
);
export const GET_FIMLAB_LABORATORIES_FAILED = createActionName(
  'GET_FIMLAB_LABORATORIES_FAILED'
);

export const getFimlabLaboratories = () => ({
  type: GET_FIMLAB_LABORATORIES,
});

export const receiveFimlabLaboratories = (data) => ({
  type: RECEIVE_FIMLAB_LABORATORIES,
  payload: { data },
});

export const getFimlabLaboratoriesFailed = (error) => ({
  type: GET_FIMLAB_LABORATORIES_FAILED,
  payload: { error },
});

export const doGetFimlabLaboratories = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(getFimlabLaboratories());
    services.api
      .getFimlabLaboratories()
      .then((data) => {
        return resolve(dispatch(receiveFimlabLaboratories(data)));
      })
      .catch((error) => {
        return reject(dispatch(getFimlabLaboratoriesFailed(error)));
      });
  });
};
